import { createSlice } from "@reduxjs/toolkit";

const refundFilterSlice = createSlice({
  name: "refundFilter",
  initialState: {
    status: null,
    search: null,
  },
  reducers: {
    setRefundFilter: (state, action) => {
      state.status = action.payload.status || null;
      state.search = action.payload.search || null;
    },

    clearRefundFilters: (state) => {
      state.status = null;
      state.search = null;
    },
  },
});

export const { setRefundFilter, clearRefundFilters } = refundFilterSlice.actions;

export const selectRefundState = (state) => state.refundFilter;

export default refundFilterSlice.reducer;
